// 计费管理模块国际化 - 中文
export default {
  title: '计费管理',
  billNo: '账单编号',
  billType: '账单类型',
  amount: '金额',
  currency: '币种',
  dueDate: '到期日',
  amountRange: '金额范围',
  dueDateRange: '到期日期',
  status: {
    pending: '待确认',
    confirmed: '已确认',
    rejected: '已驳回',
    paid: '已支付'
  },
  types: {
    shipping: '海运费',
    customs: '关税',
    portCharges: '港杂费',
    trucking: '拖车费'
  },
  actions: {
    confirm: '确认',
    reject: '驳回',
    exportData: '导出数据',
    customizeTable: '自定义表格',
    save: '保存',
    cancel: '取消',
    edit: '编辑',
    cancelEdit: '取消编辑',
    back: '返回',
    delete: '删除',
    import: '导入',
    addFees: '加入费用',
    removeFees: '移除费用',
    confirmAdd: '确认加入',
    confirmImport: '确认导入',
    confirmDelete: '确认删除',
    confirmSubmit: '确认提交',
    upload: '上传',
    refresh: '刷新',
    download: '下载',
    view: '查看',
    batchDownload: '批量下载',
    addDept: '添加部门',
    createReceivable: '新建应收',
    createPayable: '新建应付',
    cancelConfirm: '取消确认',
    submitBpm: '提交BPM审批',
    resubmitBpm: '重新提交',
    viewBpm: '查看审批',
    sendBill: '发送账单',
    confirmBill: '确认账单',
    markPaid: '标记已付款',
    markReceived: '标记已收款',
    print: '打印'
  },
  forms: {
    billNo: '账单号',
    billNoPlaceholder: '请输入账单编号',
    statusPlaceholder: '请选择状态',
    billTypePlaceholder: '请选择账单类型',
    currencyPlaceholder: '请选择币种',
    minAmount: '最小金额',
    maxAmount: '最大金额',
    settlementObject: '结算对象',
    settlementObjectPlaceholder: '请输入结算对象',
    invoiceTitle: '发票抬头',
    invoiceTitlePlaceholder: '请输入发票抬头',
    incomeExpenseType: '收支类型',
    billDate: '账单日期',
    dueDate: '账单到期日',
    counterpartBillNo: '对方账单号',
    inputPlaceholder: '请输入',
    paymentEntity: '支付主体',
    paymentEntityPlaceholder: '请选择支付主体',
    supplierBank: '供应商开户行',
    supplierBankPlaceholder: '请选择供应商开户行',
    supplierBankAccount: '供应商银行账号',
    supplierBankAccountPlaceholder: '请填写供应商银行账号',
    supplierBankAutoHint: '选择结算对象后自动带入',
    paymentInfo: '付款信息',
    remark: '备注',
    billRemarkPlaceholder: '账单级备注',
    billCurrencyLabel: '账单币种（本位币）',
    deptSelectPlaceholder: '请选择部门',
    feeSearchPlaceholder: '搜索委托单号 / 费用名称',
    priceChangeNote: '价格变动说明',
    priceChangeNotePlaceholder: '请说明本次价格变动的原因（如有差异）',
    reconciliationNo: '对账单号',
    reconciliationNoPlaceholder: '请输入对账单号',
    consignmentNo: '运输委托单号',
    reconciliationSupplier: '对账供应商',
    reconciliationSupplierPlaceholder: '请输入对账供应商',
    originalTotalUsd: '原始报价总价（USD）',
    currentTotalUsd: '对账总价（USD）',
    approvalRemark: '审批备注',
    approvalRemarkPlaceholder: '请输入审批备注',
    maxLength100: '不超过 100 字',
    maxLength50: '不超过 50 字',
    requiredSettlementObject: '请输入结算对象',
    dueDateAfterBillDate: '账单到期日须晚于账单日期',
    importFileButton: '选择文件（Excel/CSV）',
    importFormatHint: '格式：第一列为部门名称，第二列为金额（精确到小数点后2位）',
    importPreviewTitle: '预览数据：',
    settlementFlag: '是否参与结算',
    settlementFlagPlaceholder: '请选择',
    fileBusinessType: '文件类型',
    hasOriginalPaperInvoice: '是否含原始纸质票据',
    attachment: '附件',
    selectAttachment: '请选择附件',
    attachmentUploadTip: '点击或拖拽文件到此处上传'
  },
  detail: {
    newPayableBill: '新建应付账单',
    newReceivableBill: '新建应收账单',
    inclusiveTaxAmount: '含税金额',
    exclusiveTaxAmount: '不含税金额',
    taxAmount: '税额',
    nonBizFeeAmount: '非业务费用金额',
    paymentTotalAmount: '付款申请总金额',
    deptNonBizFee: '部门非业务费用',
    deptFeeSubtotal: '部门费用小计',
    feeCurrency: '费用币种',
    originalAmount: '原币金额',
    exchangeRateToBill: '汇率（费用币种→{currency}）',
    billCurrencyAmount: '{currency} 金额',
    rateLocked: '1.000000',
    settlementBill: '结算账单',
    billAmountWithCurrency: '账单金额（{currency}）',
    addFeeModalTitle: '加入费用',
    importDeptFeeModalTitle: '导入部门非业务费用',
    removeFeeModalTitle: '移除费用',
    removeFeeModalContent: '确认移除已选的 {count} 项费用？',
    settlementFilterAlert: '已按结算对象「{name}」筛选，仅可勾选相同结算对象的费用',
    addFeeExistingOnBillHint:
      '已在账单明细中的费用不会出现在本列表（仅展示未挂账费用）；追加费用须与当前账单结算对象一致。',
    selectedCount: '已选 {count} 项',
    emptyFees: '暂无费用，点击「加入费用」添加',
    emptyDeptFees: '暂无部门费用',
    emptyBills: '暂无账单记录',
    basicInfo: '基本信息',
    externalWriteOffRecord: '外部核销记录',
    emptyExternalWriteOffRecord: '暂无外部核销记录',
    billSlipDetailModalTitle: '水单凭证明细',
    emptyBillSlipDetails: '暂无水单凭证明细',
    billSlipRawRequest: '原始报文',
    fileHistory: '文件历史',
    emptyFileHistory: '暂无文件',
    externalApprovalHistory: '外部审批历史',
    emptyExternalApprovalHistory: '暂无外部审批历史',
    uploadFileModalTitle: '上传结算账单文件',
    deleteFileModalTitle: '删除文件？',
    deleteFileModalContent: '文件「{name}」将从当前账单文件历史中移除，云端文件不会被物理删除。',
    deleteFilesModalTitle: '删除文件？',
    deleteFilesModalContent: '已选 {count} 个文件将从当前账单文件历史中移除，云端文件不会被物理删除。',
    feeDetails: '明细费用',
    noFeeResults: '无查询结果',
    selectBillForFees: '请在上方选择账单行查看费用明细'
  },
  billingTab: {
    deleteConfirmTitle: '确认删除账单？',
    deleteConfirmContent:
      '账单号：{billNo}；结算对象：{settlementObject}。删除后无法恢复，已关联的 TC 费用数据不受影响。',
    bpmModalTitle: '提交BPM审批'
  },
  columns: {
    businessNo: '业务编号',
    feeName: '费用名称',
    incomeExpense: '收支',
    payType: '支付类型',
    unit: '单位',
    paymentEntityCountry: '支付主体国家',
    paymentEntity: '支付主体',
    quantity: '数量',
    unitPrice: '单价',
    taxRate: '税率',
    referenceNo: '业务/客户参考号',
    dept: '部门',
    deptName: '部门名称',
    operation: '操作',
    billCurrency: '账单币种',
    externalApprovalStatus: '外部审批状态',
    externalApprovalTime: '外部审批时间',
    externalApprovalOpinion: '外部审批意见',
    externalRejectReason: '外部拒绝原因',
    invoiceStatus: '发票状态',
    writeoffStatus: '核销状态',
    bpmApproval: 'BPM审批',
    origin: '来源',
    feeType: '费用类型',
    region: '国内国外',
    estimatedAmountWithTax: '预估金额（含税）',
    baseCurrency: '本位币币种',
    baseCurrencyAmount: '折合本位币金额',
    waybillNo: '所属运单',
    createTime: '创建时间',
    createdBy: '创建人',
    receiptAction: '操作',
    receiptStatus: '收票状态',
    receivedAmount: '已收票金额',
    unreceivedAmount: '未收票金额',
    settlementFlag: '是否参与结算',
    fileName: '文件名',
    fileBusinessType: '文件类型',
    hasOriginalPaperInvoice: '纸质票据',
    fileSize: '大小',
    uploadTime: '上传时间',
    uploadUserId: '上传人',
    paymentApplicationNo: '付款申请号',
    requestId: '请求ID',
    account: '银行科目',
    paymentMethod: '支付方式',
    actualPaymentAmount: '实际支付金额',
    exchangeRate: '汇率',
    writeOffCompleteTime: '核销完成时间',
    processStatus: '处理状态',
    errorMessage: '失败原因',
    receiveTime: '接收时间',
    billSlipNo: '水单号',
    billSlipType: '水单类型',
    billSlipDate: '水单日期',
    billSlipFileUrl: '附件',
    fileId: '文件ID'
  },
  receipt: {
    externalOcrUpload: '外部发票 OCR 识别',
    externalOcrOpened: '已打开外部发票 OCR 上传页面',
    externalOcrNoUploadUrl: '未获取到外部发票 OCR 上传地址',
    externalOcrSelectSingleBill: '请先选择一张账单进行外部发票 OCR 识别',
    externalOcrBillRequired: '当前收票账单缺少账单号或账单ID',
    title: '账单收票 — {billNo}',
    batchTitle: '批量收票',
    historyTitle: '收票记录 — {billNo}',
    settlementHistoryTitle: '收票记录',
    openReceipt: '收票',
    receiptHistory: '收票记录',
    batchReceipt: '批量收票',
    batchReceiptN: '批量收票（{count}）',
    saveReceipt: '保存收票',
    cancel: '取消',
    fullReceipt: '全额收票',
    inputAmount: '请输入金额',
    inputPlaceholder: '请输入',
    dash: '—',
    fullReceived: '已全收',
    partialReceived: '部分收票',
    notReceived: '未收票',
    feeCountSelected: '已选 {count} 条费用',
    feeCount: '条费用',
    billCount: '张账单',
    feeSaved: '已为 {count} 条费用保存收票记录',
    billSaved: '已为 {count} 张账单保存收票记录',
    noFeeData: '该账单暂无费用数据',
    noBillData: '暂无账单数据',
    noReceiptHistory: '暂无收票记录',
    noReceiptHistoryHint: '该账单暂无收票记录，请先点击「批量收票」录入发票信息',
    selectFees: '勾选需要收票的费用，并填写本次收票金额（不可超过可收金额）',
    selectBills: '勾选需要收票的账单，并填写本次收票金额（不可超过账单金额）',
    invoiceTypeRequired: '请选择发票类型',
    invoiceNoRequired: '请填写发票号',
    invoiceDateRequired: '请选择发票日期',
    exchangeRateRequired: '请输入汇率',
    billingTitleRequired: '请输入开票抬头',
    receivingTitleRequired: '请输入收票抬头',
    taxExclusiveAmountRequired: '请输入不含税额',
    selectAtLeastOneFee: '请至少勾选一条费用',
    selectAtLeastOneBill: '请至少勾选一张账单',
    fillFeeAmount: '请填写「{name}」的收票金额',
    feeFullyReceived: '「{name}」已无可收票金额，请取消勾选',
    amountExceed: '「{name}」收票金额不能超过可收金额 {currency} {amount}',
    billAmountExceed: '「{name}」收票金额不能超过账单金额 {currency} {amount}',
    selectBillFirst: '请先勾选需要收票的账单',
    selectBillForHistory: '请先勾选需要查看的账单',
    selectBillWarning: '所选账单下暂无费用数据',
    receiptBatches: '收票批次',
    billAmountLabel: '账单金额',
    totalReceivedLabel: '累计已收发票金额',
    billStatusLabel: '账单状态',
    summaryLabel: '查看账单：{billCount} 张 / 收票批次合计：{batchCount} 条',
    feeName: '费用名称',
    feeType: '类型',
    totalFeeAmount: '费用金额',
    received: '已收票',
    canReceive: '可收金额',
    thisReceiptAmount: '本次收票金额',
    thisReceiptAmountRequired: '本次收票金额 *',
    billName: '所属账单',
    payable: '应付',
    receivable: '应收',
    receiptHistoryColumns: {
      batch: '批次',
      invoiceNo: '发票号',
      invoiceType: '发票类型',
      totalAmount: '金额合计',
      amountExcludingTax: '不含税额',
      taxRate: '税率',
      feeCount: '收票费用数',
      invoiceDate: '发票日期',
      createdBy: '录入人',
      createdAt: '录入时间',
      billNo: '账单号',
      batchAmount: '本批收票金额',
      issuerTitle: '开票抬头'
    },
    invoiceType: '发票类型',
    invoiceNo: '发票号码',
    invoiceDate: '发票日期',
    exchangeRate: '汇率',
    billingTitle: '开票抬头',
    receivingTitle: '收票抬头',
    taxExclusiveAmount: '不含税额',
    taxRate: '税率',
    taxAmount: '税额',
    totalAmount: '金额合计',
    remark: '收票备注',
    attachment: '发票附件',
    uploadAttachment: '上传发票附件（PDF / PNG / JPG / OFD）',
    remarkPlaceholder: '选填，最多 200 字',
    billingTitlePlaceholder: '请输入开票方名称',
    receivingTitlePlaceholder: '请输入收票方名称',
    invoiceNoPlaceholder: '请输入发票号码',
    invoiceTypePlaceholder: '请选择',
    invoiceTypeEnum: {
      vat_special: '增值税专用发票',
      vat_general: '增值税普通发票',
      e_general: '电子发票（普通发票）',
      e_special: '电子发票（增值税专用发票）',
      receipt: '国际小票（国外形式发票）'
    }
  },
  externalInvoiceSync: {
    action: '外部发票状态同步',
    selectShokzBill: '请选择韶音账单(AP开头的账单)',
    filteredNonShokz: '已过滤 {count} 条非韶音账单(非AP开头)，仅同步韶音账单(AP开头)',
    success: '外部发票状态同步完成：成功 {successCount} 条，失败 {failedCount} 条，未匹配 {unmatchedCount} 条',
    failed: '外部发票状态同步失败'
  },
  enums: {
    receivable: '应收',
    payable: '应付',
    billStatus: {
      DRAFT: '草稿',
      PENDING: '待确认',
      CONFIRMED: '已确认',
      DISPUTED: '争议中',
      PAID: '已付款',
      CLOSED: '已关闭',
      SENT: '已发送',
      RECEIVED: '已收款',
      OVERDUE: '逾期'
    },
    invoiceStatus: {
      ALL: '全部开票',
      PARTIAL: '部分开票',
      NONE: '未开票'
    },
    externalInvoiceStatus: {
      NOT_INVOICED: '未开票',
      NORMAL: '正常',
      VOIDED: '作废',
      RED_FLUSH: '红冲',
      ABNORMAL: '异常',
      OUT_OF_CONTROL: '失控',
      UNKNOWN: '未知'
    },
    externalApprovalStatus: {
      APPROVED: '已通过',
      REJECTED: '已拒绝'
    },
    writeoffStatus: {
      DONE: '已核销',
      NONE: '未核销'
    },
    bpmStatus: {
      none: '未提交',
      pending: '审批中',
      approved: '已通过',
      rejected: '已驳回',
      approvedDone: '已审批'
    },
    billOrigin: {
      supplier: '供应商结算',
      internal: '内部创建'
    },
    region: {
      DOMESTIC: '国内',
      FOREIGN: '国外'
    },
    settlementFlag: {
      Y: '是',
      N: '否'
    },
    fileBusinessType: {
      PAYMENT_ATTACHMENT: '付款申请附件',
      INVOICE: '发票',
      RECEIPT: '水单',
      VOUCHER: '凭证',
      OTHER: '其他'
    }
  },
  common: {
    yes: '是',
    no: '否'
  },
  messages: {
    searchSuccess: '搜索成功',
    searchFailed: '搜索失败',
    confirmSuccess: '账单 {billNo} 确认成功',
    rejectSuccess: '账单 {billNo} 驳回成功',
    exportPending: '导出功能开发中...',
    customizeTablePending: '自定义表格功能开发中...',
    feesAdded: '已加入 {count} 项费用',
    feesRemoved: '已移除',
    saveSuccess: '保存成功',
    saveFailed: '保存失败，请重试',
    paymentEntityCountryRequired: '请填写每条费用明细的支付主体国家',
    operationFailed: '操作失败',
    deleteFailed: '删除失败',
    billConfirmed: '账单已确认',
    billMarkedPaid: '已标记为已付款',
    billMarkedReceived: '已标记为已收款',
    billSent: '账单已发送',
    billDeleted: '账单已删除',
    cancelConfirmSuccess: '已取消确认',
    bpmSubmitted: 'BPM审批已提交',
    deptFeesImported: '已导入 {count} 条部门费用',
    addFeesFirst: '请先加入费用',
    paymentEntityCountryRequired: '请选择每条费用的支付主体国家',
    feePaymentEntityRequired: '请选择每条费用的支付主体',
    deletePayableOnlyDraftOrPending: '仅草稿或待确认状态应付账单可删除',
    deleteReceivableOnlyDraft: '仅草稿状态应收账单可删除',
    deleteBillBpmProtected: '正在审批或已审批通过的账单不可删除',
    priceChangeNoteRequired: '请填写价格变动说明',
    reconciliationNoRequired: '请填写对账单号',
    reconciliationSupplierRequired: '请填写对账供应商',
    reconciliationAmountRequired: '请填写对账金额',
    exchangeRateMissing:
      '未在汇率设置中找到：费用币种 {currencies} → 本位币 {currency}，请维护币种对或手动填写汇率',
    fileReadFailed: '文件读取失败，请检查格式',
    deptListEmpty: '部门列表为空，请确认已配置组织部门或联系管理员',
    deptNotFound: '部门「{name}」在系统中不存在，请使用下拉框中的部门名称',
    addFeeSettlementObjectMismatch:
      '仅可加入结算对象为「{name}」的费用，与当前账单不一致的费用无法加入',
    selectBillsToPrint: '请先勾选需要打印的账单',
    noBillPrintTemplates: '未找到可用的账单打印模板，请在系统设置中配置 schemaType 为 BILL 的模板',
    loadPrintTemplateFailed: '加载打印模板失败，请重试',
    openPrintTemplateFailed: '打开打印模板失败，请重试',
    fileListLoadFailed: '加载文件列表失败',
    externalWriteOffHistoryLoadFailed: '加载外部核销记录失败',
    externalApprovalHistoryLoadFailed: '加载外部审批历史失败',
    selectAttachmentFirst: '请先选择附件',
    selectFileFirst: '请先选择文件',
    fileUploaded: '文件已上传',
    fileUploadFailed: '文件上传失败',
    fileIdMissing: '文件 ID 为空，无法下载',
    fileDownloadFailed: '文件下载失败',
    fileDeleted: '文件已删除',
    filesDownloaded: '已开始下载 {count} 个文件',
    filesDeleted: '已删除 {count} 个文件',
    noBillSlipDetails: '暂无水单凭证明细'
  },
  settlementStatement: {
    tabs: {
      reconciliation: '对账',
      statement: '账单'
    },
    common: {
      filterTitle: '查询条件',
      queryScheme: '查询方案：',
      schemeDefault: 'default',
      schemeOne: '方案一',
      search: '查询',
      reset: '重置',
      saveScheme: '保存方案',
      saveSchemeAs: '另存为方案',
      appendQuery: '追加查询',
      all: '全部',
      dateTo: '至',
      columnSettings: '设置列',
      export: '导出',
      gotIt: '知道了',
      view: '查看',
      confirm: '确认',
      cancelConfirm: '取消确认',
      review: '复核',
      cancelReview: '取消复核',
      batchUpload: '批量上传文件',
      invoiceReceive: '开票收票',
      writeoff: '销账',
      applyPayment: '申请付款',
      etdRange: '范围',
      etdEquals: '等于'
    },
    reconciliation: {
      paymentType: '收付方式：',
      feeTypeRegion: '费用类型：',
      businessDate: '业务日期：',
      createBill: '创建账单',
      selectFeesFirst: '请先勾选需要创建账单的费用',
      settlementObjectMismatchTitle: '结算对象不一致',
      settlementObjectMismatchContent:
        '所选费用的结算对象不一致（{list}），请仅勾选同一结算对象的费用后再创建账单。',
      currencyMismatchTitle: '币种不一致',
      currencyMismatchContent:
        '所选费用的币种不一致（{list}），请仅勾选同一币种的费用后再创建账单。',
      feeTypeMismatchTitle: '收支类型不一致',
      feeTypeMismatchContent:
        '所选费用同时包含应收与应付，请仅勾选同一收支类型的费用后再创建账单。',
      feeTypeUnknown: '无法识别费用收支类型，请筛选应收或应付后重试',
      billedFeesTitle: '包含已挂账费用',
      billedFeesContent:
        '已选 {total} 条中有 {billed} 条已关联账单，创建账单请仅选择未挂账费用。'
    },
    statementFilter: {
      payType: '收付类型：',
      billStatus: '账单状态：',
      selectPayTypeFirst: '先选收付类型',
      billNo: '账单号：',
      settlementObject: '结算对象：',
      fuzzyQuery: '模糊查询',
      fuzzySearch: '模糊搜索'
    },
    billTab: {
      billListLoadFailed: '账单列表加载失败，请重试',
      feeListLoadFailed: '费用列表加载失败，请重试',
      exportPending: '导出功能开发中',
      bpmApproved: '已审批'
    },
    reconciliationColumns: {
      transportOrderNo: '运输委托单',
      feeName: '费用名称',
      feeCategory: '费用类',
      exchangeRate: '汇率',
      taxIncludedPrice: '含税价',
      taxExcludedPrice: '不含税价',
      taxAmount: '税额',
      updateTime: '更新时间',
      updateBy: '更新人'
    },
    billColumns: {
      billNo: '账单号',
      settlementObject: '结算对象',
      invoiceTitle: '发票抬头',
      billCurrency: '账单币种',
      amount: '金额',
      payType: '收支类型',
      status: '状态',
      externalApprovalStatus: '外部审批状态',
      invoiceStatus: '发票状态',
      writeoffStatus: '核销状态',
      bpmApproval: 'BPM审批',
      operation: '操作',
      createdBy: '创建人',
      createTime: '创建时间'
    }
  },
  expressReconcile: {
    title: '快递对账',
    unboundWaybill: '未绑定运单',
    actions: {
      importBill: '导入账单',
      confirmBill: '确认账单',
      parseFile: '解析文件',
      removeFile: '移除',
      previous: '上一步',
      collapse: '收起'
    },
    carriers: {
      SF: '顺丰（SF Express）',
      FEDEX: '联邦快递（FedEx）'
    },
    carrierShort: {
      SF: '顺丰',
      FEDEX: 'FedEx'
    },
    forms: {
      carrier: '快递公司',
      carrierPlaceholder: '请选择快递公司',
      billMonth: '账单月份',
      billMonthPlaceholder: '请选择账单月份',
      uploadFile: '上传账单文件',
      uploadHint: '点击选择文件（.xlsx / .xls，≤ 10MB，≤ 2000 行）',
      remark: '备注',
      remarkPlaceholder: '如：4月顺丰账单（补充导入）',
      searchWaybill: '搜索运单号',
      duplicatePolicy: '重复费用处理'
    },
    duplicatePolicy: {
      skip: '跳过重复',
      overwrite: '覆盖重复'
    },
    importModalTitle: '导入账单',
    batchInfo: '{carrier} · {month}',
    emptyDescription: '暂无对账记录，点击「导入账单」开始对账',
    stats: {
      totalWaybills: '运单总数',
      pass: '通过',
      diff: '差异',
      unmatched: '未匹配',
      diffAmountLabel: '差异总金额：',
      diffAmountHint: '（正值=快递公司多收）',
      filterAll: '全部（{count}）',
      filterPass: '通过（{count}）',
      filterDiff: '差异（{count}）',
      filterUnmatched: '未匹配（{count}）'
    },
    columns: {
      waybillNo: '运单号（快递单号）',
      expressAmount: '快递公司金额（CNY）',
      systemAmount: '系统金额（CNY）',
      diff: '差额（CNY）',
      reconcileStatus: '对账状态',
      feeName: '费用名称',
      amount: '金额（CNY）',
      feeDate: '费用日期',
      waybillNoShort: '运单号'
    },
    status: {
      PASS: '通过',
      DIFF: '差异',
      UNMATCHED: '未匹配'
    },
    drill: {
      waybillLabel: '运单号：{waybill}',
      diffTag: '差异 {amount}',
      noSystemRecord: '系统无记录',
      amountMatch: '金额一致',
      expressBill: '快递公司账单',
      systemRecord: '系统记录',
      total: '合计：',
      expressTotal: '快递侧合计：',
      systemTotal: '系统侧合计：'
    },
    confirmModal: {
      title: '确认账单',
      content: '确认后将自动调整容差范围内的系统费用，并将账单状态更新为「已确认」。是否继续？'
    },
    preview: {
      summary: '共解析 {rows} 行，涉及 {waybills} 个运单号',
      hint: '仅展示前 10 行预览，导入将包含全部数据',
      sourceRows: '源业务行',
      parsedLines: '有效费用明细',
      waybills: '运单数',
      skippedRows: '跳过数',
      appendNotice: '该承运商和月份已有 {count} 次导入，本次将追加到现有对账数据。',
      duplicateNotice: '发现 {count} 个重复的“运单号 + 费用名称”，请选择处理方式。',
      skipDetail: '跳过明细：空运单号 {waybill}，空费用名称 {feeName}，非法金额 {amount}'
    },
    monthLabel: '{year}年{month}月',
    tooltipUnmatchedBlocking: '存在 {count} 条未匹配数据，请处理后再确认',
    tooltipDiffBlocking: '存在 {count} 条差异，请处理后再确认',
    tooltipNoDataBlocking: '暂无可确认的对账数据',
    messages: {
      selectOneApBill: '请勾选一条应付账单进行快递对账',
      billNotFound: '未找到所选账单',
      apOnly: '快递对账仅支持应付（AP）账单',
      pendingApBillOnly: '快递对账仅支持待确认状态的应付（AP）账单',
      cnyOnly: '快递对账仅支持人民币（CNY）账单',
      resultLoadFailed: '对账结果加载失败，请重试',
      waybillDetailLoadFailed: '运单明细加载失败',
      confirmBillFailed: '确认账单失败，请重试',
      openDrawerFirst: '请先打开快递对账并选择应付账单',
      selectBillFile: '请选择账单文件',
      fileFormatInvalid: '仅支持 .xls 或 .xlsx 文件',
      fileTooLarge: '文件不能超过 10MB',
      parseFailed: '文件解析失败，请检查所选快递公司、账单月份和固定模板格式',
      reselectFile: '请重新选择文件',
      duplicatePolicyRequired: '请选择重复费用处理方式',
      noImportPermission: '当前账号没有导入快递账单的权限',
      noConfirmPermission: '当前账号没有确认快递对账账单的权限',
      importFailed: '导入失败，请重试',
      importSuccess:
        '导入完成，共比对 {total} 个运单号：通过 {pass} 条，差异 {diff} 条，未匹配 {unmatched} 条',
      defaultFeeName: '费用'
    }
  }
}
